<template>
  <div
    v-if="!isLoading && homeButtons"
    class="home-activities__background"
    data-testid="home-activities"
  >
    <div class="home-activities">
      <Heading :level="3">
        {{ homeButtons.title }}
      </Heading>
      <div class="home-activities__card-container">
        <CardCounter
          v-for="(button, index) in homeButtons.buttons"
          :key="index"
          class="home-activities__card-container__item"
          :icon="button.icon"
          :badge-counter="button.total"
          :label="button.label"
          @click="() => handleClick(button.type)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import { Heading } from '@warrenbrasil/nebraska-web';
import { CardCounter } from '@/modules/common/components/cards/CardCounter';

import {
  IHomeButtonsV2,
  getButtonsV2,
  EButtonTypeV2
} from '@/modules/home/services/consolidation';

const router = useRouter();

interface Emits {
  (event: 'open-register-panel'): void;
  (event: 'open-orders-panel', type: string): void;
}

const emit = defineEmits<Emits>();

const isLoading = ref(true);
const homeButtons = ref<IHomeButtonsV2 | void>();

async function fetchButtons() {
  try {
    isLoading.value = true;

    homeButtons.value = await getButtonsV2();
  } finally {
    isLoading.value = false;
  }
}

function handleClick(type: EButtonTypeV2) {
  switch (type) {
    case EButtonTypeV2.IN_PORTABILITY:
      window.location.assign('/products/#/portability');
      break;
    case EButtonTypeV2.OUT_PORTABILITY:
      router.push({ name: 'portabilityRequests' });
      break;
    case EButtonTypeV2.APPROVALS:
      router.push({ name: 'investmentSuggestions' });
      break;
    case EButtonTypeV2.REGISTER:
      emit('open-register-panel');
      break;
    case EButtonTypeV2.INVESTMENT:
      emit('open-orders-panel', type);
      break;
    case EButtonTypeV2.REDEMPTION:
      emit('open-orders-panel', type);
      break;
    default:
      break;
  }
}

onMounted(fetchButtons);
</script>

<style lang="less" scoped>
.home-activities {
  .container-width(@size-spacing-x1200, @size-spacing-x1200);

  &__background {
    background-color: @background-tertiary;
  }

  &__card-container {
    margin-top: @size-spacing-x600;
    display: flex;
    flex-wrap: wrap;
    gap: @size-spacing-x300;

    &__item {
      flex: 1 1 160px;
      max-width: 195px;
    }

    :deep(.card-counter) {
      background-color: @background-secondary;

      &:hover {
        background-color: @background-hover;
      }
    }
  }
}
</style>
